// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"fccd3016","278":"cd7d887b","439":"e849e888","882":"8fe65fed"}[chunkId] + ".chunk.js";
};